import { render } from "./FileSelect.vue?vue&type=template&id=f2e04460&scoped=true"
import script from "./FileSelect.vue?vue&type=script&lang=js"
export * from "./FileSelect.vue?vue&type=script&lang=js"

import "./FileSelect.vue?vue&type=style&index=0&id=f2e04460&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e04460"]])

export default __exports__